import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { FormFieldBase } from './form-field-base';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';
import { HttpClient } from '@angular/common/http';
import { ApiUrlService } from '@core/services/common/api-url.service';

@Component({
  selector: '[form-field-select]',
  template: `
    <div [formGroup]="formGroup">
      <mat-form-field [class]="item.uId">
        <mat-label>{{ item.content }}</mat-label>
        <mat-select [formControlName]="formName" [required]="required" [tabIndex]="item.tabindex" (selectionChange)="dataChanged($event)">
          <mat-option *ngFor="let option of options" [value]="option.id">{{ option.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="invalid">{{ getErrorMessage$() | async | translate }}</mat-error>
      </mat-form-field>

    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class FormFieldSelectComponent extends FormFieldBase implements OnInit {
  options: any[] = [];

  constructor(protected fs: FormService,
              private apiUrlService: ApiUrlService,
              private http: HttpClient) {
    super(fs);
  }

  ngOnInit() {
    const {formControlName, dataSourceUrlForSelect} = this.item.settings;
    this.fs.addControl(formControlName);
    if (dataSourceUrlForSelect) {
      const apiUrl = this.apiUrlService.getApiUrl();
      const sub = this.http.get(apiUrl + dataSourceUrlForSelect).subscribe(
        (data: { data: any[] }) => {
          this.options = data.data;
          const defaultValue = data.data.find(option => option.default === true);
          if (defaultValue) {
            this.formGroup.get(formControlName).setValue(defaultValue.id);
          }
          sub.unsubscribe();
        }
      );
    }
  }
}
